{
  "title": "الإشعارات",
  "description": "تنبيهات سيرفراتك وفواتيرك وفريقك.",
  "kinds": {
    "payment_failed": {
      "title": "تعذّر تحصيل دفعة {{amount}}",
      "body": "لم تنجح دفعة اشتراك {{server}}. ادفع خلال مهلة الدفع حتى لا تُقفل لوحة التحكم."
    },
    "invoice_paid": {
      "title": "تم دفع الفاتورة {{number}}",
      "body": "استلمنا {{amount}}. شكرًا لك."
    },
    "server_activated": {
      "title": "فُعّل {{server}}",
      "body": "السيرفر متصل ويعمل."
    },
    "server_grace": {
      "title": "{{server}} غير متصل بـ bPanel",
      "body": "المواقع تعمل كالمعتاد، لكن إضافة حسابات جديدة تتوقف إذا لم يتصل السيرفر قبل نهاية المهلة."
    },
    "update_available": {
      "title": "الإصدار {{version}} متاح",
      "body": "حدّث {{server}} للحصول على آخر التحسينات والإصلاحات."
    },
    "trial_ending": {
      "title": "تجربتك المجانية تنتهي قريبًا",
      "body": "جهّز الدفع قبل نهاية التجربة حتى لا تُقفل لوحة التحكم على سيرفراتك."
    },
    "credits_low": {
      "title": "نقاط الذكاء الاصطناعي على {{server}} قاربت على النفاد",
      "body": "اشترِ نقاطًا إضافية أو فعّل الشحن التلقائي."
    },
    "member_joined": {
      "title": "انضم {{name}} إلى الفريق",
      "body": "صلاحياته الآن حسب دوره."
    },
    "ticket_reply": {
      "title": "رد جديد على التذكرة {{number}}",
      "body": "رد فريق الدعم على تذكرتك."
    },
    "server_key_reissued": {
      "title": "مفتاح تفعيل جديد لـ {{server}}",
      "body": "أصدر {{name}} مفتاحًا جديدًا. ينتقل السيرفر إليه تلقائيًا عند اتصاله التالي، ثم يتوقف المفتاح القديم."
    },
    "server_transfer_started": {
      "title": "بدأ نقل {{server}}",
      "body": "ثبّت bPanel على السيرفر الجديد بمفتاح التفعيل الجديد."
    },
    "server_old_installation_deactivated": {
      "title": "توقف التثبيت القديم على {{server}}",
      "body": "اتصل السيرفر القديم وتوقف اشتراكه عليه. المواقع عليه تستمر في العمل."
    },
    "credits_exhausted": {
      "title": "نفدت نقاط الذكاء الاصطناعي على {{server}}",
      "body": "طلبات الذكاء الاصطناعي متوقفة على هذا السيرفر حتى تشتري نقاطًا أو يتجدد الرصيد الشهري."
    },
    "credits_topped_up": {
      "title": "أضفنا {{credits}} نقطة إلى {{server}}",
      "body": "اشترى الشحن التلقائي النقاط لأن الرصيد قارب على النفاد."
    },
    "release_published": {
      "title": "صدر bPanel {{version}}",
      "body": "إصدار جديد على القناة $t(notifications:channels.{{channel}}). اطّلع على الجديد وعلى السيرفرات التي يمكن تحديثها."
    },
    "ticket_resolved": {
      "title": "حُلّت التذكرة {{number}}",
      "body": "أغلق فريق الدعم التذكرة. قيّم التجربة، أو أعد فتحها إذا استمرت المشكلة."
    },
    "server_past_due": {
      "title": "اشتراك {{server}} بانتظار الدفع",
      "body": "لم تنجح دفعة التجديد. السيرفر يعمل كالمعتاد، وتُقفل لوحة التحكم إذا لم تدفع خلال مهلة الدفع."
    },
    "server_locked": {
      "title": "لوحة تحكم {{server}} مقفلة",
      "body": "انتهى الاشتراك. المواقع والبريد وقواعد البيانات وDNS تعمل، ولا نحذف أي شيء. جدّد الاشتراك لفتح اللوحة."
    },
    "server_unlocked": {
      "title": "فُتحت لوحة تحكم {{server}}",
      "body": "اتصل السيرفر بـ bPanel بعد التجديد، وكل شيء يعمل."
    }
  },
  "filters": {
    "all": "الكل",
    "unread": "غير المقروءة",
    "label": "عرض الإشعارات",
    "category": "النوع",
    "markCategory": "تحديد {{category}} كمقروءة"
  },
  "empty": {
    "unreadTitle": "قرأت كل الإشعارات",
    "body": "تظهر هنا التنبيهات المهمة عن سيرفراتك وفواتيرك وفريقك.",
    "categoryTitle": "لا توجد إشعارات من هذا النوع"
  },
  "channels": {
    "stable": "المستقرة",
    "beta": "التجريبية"
  },
  "categories": {
    "all": "كل الأنواع",
    "billing": "الفوترة",
    "servers": "السيرفرات",
    "updates": "التحديثات",
    "team": "الفريق",
    "support": "الدعم",
    "other": "أخرى"
  },
  "preferences": "إعدادات الإشعارات",
  "fallback": {
    "title": "إشعار جديد",
    "body": "افتحه لعرض التفاصيل."
  }
}
